import ResourceConfig from './resource.config';
import ResourceUsersController from './resource.users.controller'
import FhomeRadioResourceUsersController from './fhomeradio.resource.users.controller';
import ResourceNotFoundUsersController from './notFound.resource.users.controller'

let resourceModule = angular.module('ff.users.resource', []);

resourceModule.config(ResourceConfig);
resourceModule.controller('ResourceUsersController', ResourceUsersController);
resourceModule.controller('FhomeRadioResourceUsersController', FhomeRadioResourceUsersController);
resourceModule.controller('ResourceNotFoundUsersController', ResourceNotFoundUsersController);


resourceModule.run(['$rootScope', '$localStorage', ($rootScope, $localStorage) => {
  $rootScope.$on('event:auth-loginCancelled', function(event, data){
    if($localStorage.loggedUser){
      $localStorage.loggedUser.currentResource = null;
      $localStorage.loggedUser.currentResourceCredentails = null;
    }
  });
}]);

export default resourceModule = resourceModule.name;



// WEBPACK FOOTER //
// ./src/users/resource/resource.module.js